import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import './assets/styles/styles.module.css';
import './assets/styles/index.css';
import 'mapbox-gl/dist/mapbox-gl.css';
import mapboxgl from 'mapbox-gl';

import 'nprogress/nprogress.css';
import App from 'src/App';
import { SidebarProvider } from 'src/contexts/SidebarContext';
import * as serviceWorker from 'src/serviceWorker';
import { AuthProvider } from './contexts/JwtAuthContext';
import { DrawerProvider } from './contexts/DrawerContext';
import { ModalProvider } from './contexts/ModalDialogContext';
import { MAP_BOX_TOKEN } from './api/constants';

// Set Mapbox access token globally before app initialization
if (MAP_BOX_TOKEN) {
  mapboxgl.accessToken = MAP_BOX_TOKEN;
} else {
  console.warn('Mapbox token is not configured. Please set REACT_APP_MAP_BOX_TOKEN environment variable.');
}

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(
    <HelmetProvider>
      <AuthProvider>
        <SidebarProvider>
          <BrowserRouter>
            <DrawerProvider>
              <ModalProvider>
                <App />
              </ModalProvider>
            </DrawerProvider>
          </BrowserRouter>
        </SidebarProvider>
      </AuthProvider>
    </HelmetProvider>
  );
}

serviceWorker.unregister();
